export default __webpack_public_path__ + "static/media/tigerNew.118d25d9.png";